module.exports = "/fonts/vendor/lightgallery/lg.svg?09cd8e9be7081f2166444cce393fe968";